module.exports = __webpack_public_path__ + "static/img/hot-Grade1.48e9b6d2.png";